import { addedLazyLoadImages } from "@/scripts/helpers/imgLazyload";
import "slick-carousel/slick/slick";
import contactForm from "@/modules/blocks/contact-form/index";
import { initWowLibrary } from "@/scripts/helpers/wowAnimation";
import lottie from "lottie-web";
import { animationData } from "@/scripts/animation-data/animatedMail";

const animateFormClass = ".js-ready-animate-form";
const animateClass = ".js-ready-animate";
let animateWasPlayedFlag = false;

const inView = function(element) {
  const win = $(window);
  const obj = element;
  const scrollPosition = win.scrollTop();
  const visibleArea = win.scrollTop() + win.height();
  const objEndPos = obj.offset().top;

  return visibleArea >= objEndPos && scrollPosition <= objEndPos;
};

const dataAnimation = () => {
  let params = {
    container: document.getElementById("animatedMail"),
    renderer: "svg",
    loop: false,
    autoplay: true,
    animationData: animationData
  };

  lottie.loadAnimation(params);
};

const startAnimation = () => {
  const animate = document.querySelector(animateClass);
  const animateForm = document.querySelector(animateFormClass);

  if (animateForm !== null) {
    $(".form-wrapper").addClass("animate-form-visible");
  }

  if (animate !== null) {
    if ($(window).height() <= 768) {
      window.addEventListener("scroll", event => {
        if (!animateWasPlayedFlag && inView($(animate))) {
          dataAnimation();
          animateWasPlayedFlag = true;
        }
      })
    } else {
      dataAnimation();
      animateWasPlayedFlag = true;
    }
  }
};

const reviewSlider = () => {
  const slider = $(".review-slider");
  const nextArrow = $(".js-slider-arrow .btn-next-arrow");
  const prevArrow = $(".js-slider-arrow .btn-prev-arrow");

  slider.on("init reInit afterChange", function(
    event,
    slick,
    currentSlide,
    nextSlide
  ) {
    if (!slick.$dots) {
      return;
    }

    const counter = (currentSlide ? currentSlide : 0) + 1;
    const sumCounter = slick.$dots[0].children.length;

    if (counter === 1) {
      prevArrow.addClass("is-disable");
      nextArrow.removeClass("is-disable");
    } else if (counter === sumCounter) {
      nextArrow.addClass("is-disable");
      prevArrow.removeClass("is-disable");
    } else {
      nextArrow.removeClass("is-disable");
      prevArrow.removeClass("is-disable");
    }
  });

  slider.slick({
    infinite: false,
    slidesToShow: 1,
    speed: 200,
    arrows: false,
    accessibility: true,
    ariaPolite: true,
    adaptiveHeight: true,
    dsf: false,
    dots: true,
    swipe: false,
    fade: true,
    cssEase: "ease-in",
    responsive: [
      {
        breakpoint: 959,
        settings: {
          swipe: true
        }
      }
    ]
  });

  nextArrow.click(function(e) {
    slider.slick("slickNext");
  });
  prevArrow.click(function(e) {
    slider.slick("slickPrev");
  });
};

$(document).ready(function() {
  addedLazyLoadImages();
  reviewSlider();
  startAnimation();
  contactForm();
  initWowLibrary();

  $("[data-micromodal-trigger]").click(function(e) {
    e.preventDefault();
  });
});
